import LayoutMain from './layout-main'

export default LayoutMain
